import Vue from 'vue'
import App from './App.vue'
import router from './router'
import Navigation from './components/Navigation'
import Footer from './components/Footer'
import VueSilentbox from 'vue-silentbox'
import BootstrapVue from 'bootstrap-vue'
import VueSimpleAlert from 'vue-simple-alert'
import VueLazyload from 'vue-lazyload'
 
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
Vue.use(VueSimpleAlert)
Vue.use(VueSilentbox)
Vue.use(BootstrapVue)
Vue.use(VueLazyload, {
  preLoad:1.3
})
Vue.config.productionTip = false

Vue.component('Navigation',Navigation);
Vue.component('Footer', Footer);
new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
